import React, { useEffect, useState } from "react";
import { Col, Card, CardBody, CardTitle } from "reactstrap";
import { notificationsData } from "common/data";
import { Notification } from "./type";
import moment from "moment";
import SimpleBar from "simplebar-react";
import { getNotifications } from "utils/apiService";

const Notifications: React.FC = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const userId = user?.id;
        /* const offset = 0; */

        const res = await getNotifications(userId);
        const formatted = (res.response.notifications || []).map(
          (item: any) => ({
            title: item.title,
            description: item.message,
            date: moment(item.created_at).format("DD MMM YYYY"),
          })
        );

        setNotifications(formatted);
        console.log("Notifications", res.response.notifications, formatted);
      } catch (err) {
        console.error("Failed to fetch notifications:", err);
      }
    };

    fetchNotifications();
  }, []);

  return (
    <React.Fragment>
      <Col
        xl={12}
        style={{
          padding: "calc(70px + 24px) calc(24px * 0.75) 60px calc(24px * 0.75)",
        }}
      >
        <Card>
          <CardBody>
            <CardTitle tag="h4" className="mb-4">
              Notifications
            </CardTitle>
            <SimpleBar>
              {notifications.length === 0 ? (
                <div className="text-center text-muted py-3">No data found</div>
              ) : (
                <ul className="list-group">
                  {notifications.map((item: Notification, index: number) => (
                    <React.Fragment key={index}>
                      <li className="list-group-item border-0">
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3"></div>
                          <div className="flex-grow-1">
                            <h5 className="font-size-14">{item.title}</h5>
                            <p className="text-muted">{item.description}</p>
                            <p className="text-muted mb-0">{item.date}</p>
                          </div>
                        </div>
                      </li>
                      {index < notifications.length - 1 && (
                        <hr className="my-2" />
                      )}
                    </React.Fragment>
                  ))}
                </ul>
              )}
            </SimpleBar>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default Notifications;
